export default __webpack_public_path__ + "static/media/extreme-sport-electro.f60761e7.mp3";